import styled, { css } from "styled-components";

interface IInputContainer {
	hasError: boolean;
	isToShowContentSelectedNumber: number;
	$isDark?: boolean;
}

interface IHeader {
	hasBorder?: boolean;
	isToShowSearchBarMobile?: boolean;
}

export const SearchContainer = styled.form<IHeader>`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 240px;

  flex-direction: column;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: ${(props) => (!!props.isToShowSearchBarMobile ? "flex" : "none")};
    align-items: flex-start;
    justify-content: center;

    flex-direction: column;

    margin: 0;
    max-width: 380px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    max-width: 380px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    max-width: 320px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-width: 240px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-left: 12px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    max-width: 280px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 320px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    max-width: 260px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) and (max-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    max-width: 300px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    max-width: 320px;
  }
`;

export const InputContainer = styled.div<IInputContainer>`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding-left: 12px;

  height: 31px;

  border: 1px solid
    ${(props) =>
      props.hasError
        ? "#FF3838"
        : props.$isDark
          ? "rgba(255, 255, 255, 0.12)"
          : "#B6B6B6"};
  border-radius: ${(props) => (props.$isDark ? "999px" : "6px")};
  box-sizing: border-box;
  background: ${(props) => (props.$isDark ? "#161b22" : "transparent")};

  
  > svg {
    color: ${(props) => (props.$isDark ? "#8b949e" : "#b6b6b6")};
  }

  > input {
    width: 150px;

    margin-left: 12px;

    border: 0;

    background: transparent;
    color: ${(props) => (props.$isDark ? "#f0f6fc" : "inherit")};

    font-size: 12px;

    &::placeholder {
      color: ${(props) =>
        props.hasError ? "#FF3838" : props.$isDark ? "#6e7681" : "#B6B6B6"};
    }
  }

  > button#content-selected-button {
    padding: 0;

    width: 22px;
    height: 22px;

    margin-right: 8px;

    background: #cce6ea;

    border: 0;

    border-radius: 6px;

    font-size: 12px;
    color: #666666;

    visibility: ${(props) =>
		props.isToShowContentSelectedNumber >= 1 ? "visible" : "hidden"};
  }

  > button {
    border: 0;
    
    background: #6ea5ff;

    font-size: 13px;
    font-weight: 600;
    color: #fff;

    height: 31px;

    padding: 0 12px;
    
    border-radius: 0 6px 6px 0; 
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-left: 8px;
    height: 35px;
    width: 100%;
    min-width: 0;

    > svg {
      width: 19px;
      height: 19px;
      flex-shrink: 0;
    }

    > input {
      width: auto;
      flex: 1;
      min-width: 0;

      font-size: 12px;

      &::placeholder {
        font-size: 12px;
      }
    }

    > button#content-selected-button {
      width: 24px;
      height: 24px;

      margin-right: 4px;

      font-size: 12px;
    }

    > button {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 35px;

      padding: 12px 6px 12px 12px;

      font-size: 12px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    padding-left: 8px;
    height: 35px;
    width: 100%;
    min-width: 0;

    > svg {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }

    > input {
      width: auto;
      flex: 1;
      min-width: 0;
      margin-left: 8px;
      font-size: 12px;

      &::placeholder {
        font-size: 12px;
      }
    }

    > button#content-selected-button {
      margin-right: 4px;
      width: 22px;
      height: 22px;
      flex-shrink: 0;
    }

    > button {
      height: 35px;
      padding: 0 10px;
      font-size: 12px;
      flex-shrink: 0;
      white-space: nowrap;
    }
  }

  @media (min-width: 1441px) {
    height: 35px;

    > svg {
      width: 18px;
      height: 18px;
    }

    > input {
      width: 170px;

      font-size: 14px;
    }

    > button {
      font-size: 14px;

      height: 35px;
    }

    > button#content-selected-button {
      width: 27px;
      height: 27px;

      font-size: 14px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 100%;
    min-width: 0;
    overflow: hidden;

    > svg {
      flex-shrink: 0;
    }

    > input {
      width: auto;
      flex: 1;
      min-width: 0;
      margin-left: 8px;
    }

    > button#content-selected-button {
      margin-right: 4px;
      flex-shrink: 0;
    }

    > button {
      padding: 0 10px;
      font-size: 12px;
      flex-shrink: 0;
      white-space: nowrap;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    width: 100%;
    min-width: 0;
    overflow: hidden;

    > svg {
      flex-shrink: 0;
    }

    > input {
      width: auto;
      flex: 1;
      min-width: 0;
      margin-left: 10px;
    }

    > button#content-selected-button {
      margin-right: 6px;
      flex-shrink: 0;
    }

    > button {
      padding: 0 12px;
      flex-shrink: 0;
      white-space: nowrap;
    }
  }
`;

export const OptionsToSearch = styled.div`
  background: #eeeeee;

  padding: 0 24px;

  width: 221px;
  height: 320px;

  overflow: auto;

  position: absolute;
  top: 32px;
  left: 0;

  z-index: 12;

  -webkit-box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.75);

  @media (max-width: 767px) {
    width: 189px;

    top: 36px;
    left: 0;
  }

  @media (min-width: 1441px) {
    top: 35px;

    width: 252px;
  }
`;

export const ContentSelectedContainer = styled.div`
  background: #eeeeee;

  padding: 0 8px;

  width: 221px;
  height: 320px;

  overflow: auto;

  position: absolute;
  top: 32px;
  left: 0;

  z-index: 12;

  -webkit-box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.75);

  @media (max-width: 767px) {
    padding: 0 6px;

    width: 189px;

    top: 36px;
    left: 0;
  }

  @media (min-width: 1441px) {
    top: 35px;

    width: 252px;
  }
`;

export const ContentSelectedTag = styled.div`
  display: flex;
  align-items: center;

  padding: 8px;

  margin: 12px 0;

  border-radius: 6px;

  background: #cce6ea;

  overflow: hidden;
  text-overflow: ellipsis;

  > p {
    font-size: 12px;
  }

  > button {
    background: transparent;

    border: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-left: auto;
  }

  @media (max-width: 767px) {
    > p {
      font-size: 12px;
    }

    > button {
      > svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  @media (min-width: 1441px) {
    > p {
      font-size: 16px;
    }
  }
`;

export const NeighborhoodsOptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  flex-direction: column;

  padding-bottom: 6px;

  > h3 {
    font-size: 16px;
  }

  > button {
    font-size: 13px;
    color: #666666;

    margin-top: 8px;
    margin-left: 12px;

    text-align: start;

    border: 0;
    background: transparent;

    & + button {
      margin-top: 16px;
    }
  }

  @media (max-width: 767px) {
    > h3 {
      font-size: 14px;
    }

    > button {
      font-size: 12px;
    }
  }

  @media (min-width: 1441px) {
    > h3 {
      font-size: 18px;
    }

    > button {
      font-size: 16px;
    }
  }
`;

export const CitiesOptionsContainer = styled.div`
  margin-top: 16px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding-bottom: 6px;

  > h3 {
    font-size: 16px;
  }

  > a {
    text-decoration: none;

    font-size: 13px;
    color: #666666;

    margin-top: 8px;
    margin-left: 12px;

    border: 0;
    background: transparent;

    & + a {
      margin-top: 16px;
    }
  }

  @media (max-width: 767px) {
    > h3 {
      font-size: 14px;
    }

    > a {
      font-size: 12px;
    }
  }

  @media (min-width: 1441px) {
    > h3 {
      font-size: 18px;
    }

    > a {
      font-size: 16px;
    }
  }
`;